export const actionOnVehiclesTabs: IActionOnVehiclesTabs = {
  registerVehicles: 'Register Vehicles',
  viewVehicleHistory: 'View Vehicle History',
};

export interface IActionOnVehiclesTabs {
    registerVehicles: string;
    viewVehicleHistory: string;
}
